export const BID_DRAFT_TABS = ['Plan', 'Draft'] as const;
